module.exports = __webpack_public_path__ + "img/b3.6d55b94e.webp";